const divConfirmCreateUser = {
  text: 'Conta criada com sucesso',
  link: 'Link expirado'
};

export default divConfirmCreateUser;
